<template>
    <Head title="Home"/>

    <div class="relative flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
        <div class="flex flex-row justify-between">
            <div class="px-6 py-4">
                <span class="text-gray-300 font-bold">BETA</span>
            </div>
            <div class="px-6 py-4">
                <div v-if="$page.props.auth.user" class="hidden sm:flex sm:items-center sm:ml-6">
                    <!-- Settings Dropdown -->
                    <div class="ml-3 relative">
                        <BreezeDropdown align="right" width="48">
                            <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button type="button"
                                                    class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150">
                                                {{ $page.props.auth.user.name }}

                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd"
                                                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                            </button>
                                        </span>
                            </template>

                            <template #content>
                                <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                                    Log Out
                                </BreezeDropdownLink>
                            </template>
                        </BreezeDropdown>
                    </div>
                </div>

                <template v-else>
                    <Link :href="route('login')" class="text-sm text-gray-700 underline">
                        Log in
                    </Link>

                    <Link :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                        Register
                    </Link>
                </template>
            </div>
        </div>
        <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
            <div class="flex justify-center pt-8 sm:justify-start sm:pt-0">
                <Link :href="route('tig::levels.index')">
                    <img src="../../../../assets/TIGlogo.png" class="w-1/4" alt="logo"/>
                </Link>
            </div>
            <div class="mt-8 flex flex-row justify-between">
                <h1 class="text-3xl font-semibold text-gray-900">Users</h1>
            </div>

            <div v-for="user in users" class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
                <div class="p-6">
                    <div class="flex items-center">
                        <div class="ml-4 leading-7">
                            <Link :href="route('tig::users.show', user.id)"
                                  class="text-lg font-semibold underline text-gray-900 dark:text-white">
                                {{ user.name }}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-4 sm:items-center sm:justify-between">
                <div class="text-center text-sm text-gray-500 sm:text-left">
                    <div class="flex items-center">
                        Crafted with
                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                             stroke-width="2" viewBox="0 0 24 24" class="mx-1 -mt-px w-4 h-4 text-red-500">
                            <path
                                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                        </svg>
                        By
                        <a href="https://bird.cafe" class="ml-1 underline">
                            Bird Cafe
                        </a>
                        <span class="ml-1">| </span>
                        <a href="https://patreon.com/seebeyond" class="ml-1 underline" style="color: #FF424D;">Support us on Patreon!</a>
                    </div>
                </div>
                <div class="ml-4 text-center text-sm text-gray-500 sm:text-right sm:ml-0">
                    Not affiliated with <a class="underline" href="https://www.flukegames.com/">Fluke Games</a> or <a class="underline" href="https://impossible.game">TIG 2</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Head, Link} from '@inertiajs/inertia-vue3';
import BreezeDropdown from "@/Components/Dropdown";
import BreezeDropdownLink from "@/Components/DropdownLink";

export default {
    components: {
        Head,
        Link,
        BreezeDropdown,
        BreezeDropdownLink,
    },
    props: {
        auth: Object,
        users: Array,
    }
}
</script>
